import type { Nil, TryGetValue } from "@mcwd/typescript-type-guards";

export interface IRegionNameAndCode<TName extends string, TCode extends string> {
  name: TName;
  code: TCode;
}

export function createPrivacyRegion<const TPrivacyRule extends string, const TCountry extends IRegionNameAndCode<string, string>, const TStateOrTerritory extends IRegionNameAndCode<string, string> | Nil>(
  privacyRule: TPrivacyRule,
  country: TCountry,
  stateOrTerritory?: TStateOrTerritory
): { readonly privacyRule: TPrivacyRule, readonly countryName: TCountry["name"], readonly countryCode: TCountry["code"], readonly stateOrTerritoryName: TryGetValue<TStateOrTerritory, "name", Nil>, readonly stateOrTerritoryCode: TryGetValue<TStateOrTerritory, "code", Nil> } {
  const result = {
    privacyRule,
    countryName: country.name as TCountry[ "name" ],
    countryCode: country.code as TCountry[ "code" ],
    stateOrTerritoryName: stateOrTerritory?.name as TryGetValue<TStateOrTerritory, "name", Nil>,
    stateOrTerritoryCode: stateOrTerritory?.code as TryGetValue<TStateOrTerritory, "code", Nil>
  } as const;
  Object.freeze(result);
  return result;
}